import React, { Dispatch, useEffect, useReducer, useState } from 'react';
import { CaseId } from 'modules/cm/api/cases/types';
import { Credit } from 'modules/cm/pages/CaseDetailsPage/subPages';
import { CreditCheckResult, CreditCheckType } from '../Credit';
import { caseApi } from 'modules/cm/api';
import { createInitialState, error, reducer, success, start, reset } from 'utils/store/localItemsStore';
import { State as LocalItemsState } from 'utils/store/localItemsStore/types';
import { createCreditCheckResult } from 'modules/cm/pages/CaseDetailsPage/subPages/Credit/Credit';

interface Props {
  caseId: CaseId;
}

const isError = (error: any): error is Error => {
  return error.message;
};

const getCreditSearchHistoryUseCase = (caseId: CaseId): Promise<CreditCheckResult[]> => {
  return caseApi(caseId).creditApi.get();
};

const generateNewSoftCheckUseCase = (fetchDispatch: Dispatch<any>) => async (
  caseId: CaseId,
): Promise<CreditCheckResult | never> => {
  fetchDispatch(start());
  try {
    const result = await caseApi(caseId).creditApi.softCheck();
    fetchDispatch(success(result));
    return result;
  } catch (err) {
    throw new Error(err);
  }
};

const CreditContainer: React.FC<Props> = ({ caseId }) => {
  const [history, setHistory] = useState<CreditCheckResult[]>([]);
  const [current, setCurrent] = useState<CreditCheckResult>();
  const [fetchState, fetchDispatch] = useReducer<React.Reducer<LocalItemsState<CreditCheckResult>, any>>(
    reducer,
    createInitialState(createCreditCheckResult(), false),
  );

  useEffect(() => {
    try {
      getCreditSearchHistoryUseCase(caseId).then((results) => {
        const softChecks = results.filter(
          (item) => item.type === CreditCheckType.SOFT || item.type === CreditCheckType.SOFT_MANUAL,
        );
        setCurrent(softChecks[0]);
        setHistory(results);
      });
    } catch (error) {}
  }, [caseId]);

  const handleGenerateSoftCheck = async () => {
    try {
      const res = await generateNewSoftCheckUseCase(fetchDispatch)(caseId);
      setCurrent(res);
      setHistory((history) => [res, ...history]);
    } catch (err) {
      if (isError(err)) {
        fetchDispatch(error(err.message));
      }
    }
  };

  return (
    <Credit
      current={current}
      history={history}
      onGenerateSoftCheck={handleGenerateSoftCheck}
      isLoading={fetchState.pending}
      error={fetchState.error}
      onModalClose={() => fetchDispatch(reset(createInitialState(createCreditCheckResult(), false)))}
    />
  );
};

export default CreditContainer;
